import React from 'react';
import { BsEmojiDizzyFill } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ProjectsEndpoints } from '../../Routes/api/Endpoints';
import { PROJECTSACCUEIL } from '../../Routes/navigation/navigationPaths';
import { selectData } from '../../redux/features/userSliceWithTokenValidation';
// import { useFetchProjectsQuery } from '../../services/auth-services/AuthService';
import { useFetchProjectsQuery } from '../../services/auth-services/TacheService';
import CardprojectComponent from '../Client/dashboardComponents/CardprojectComponent';
import SkeletonLoader from '../Utils/Skeleton';
import MonBouton from '../Utils/design-system/buttons/MonBouton';
import ProjectCards from './ProjectCards';
import SelectCategory from './SelectCategory';
function ProjectSection({ display, position, title, description, width, button, contener, selectCat }) {
  const navigate = useNavigate();
  const { data: projets, isLoading } = useFetchProjectsQuery(ProjectsEndpoints.getProjects, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true, // Rafraîchit quand l'onglet redevient actif
    skip: false
  });
  const validProjects = projets?.filter((proj) => proj.validation_projet === "VALIDE")
  const user = useSelector(selectData)
  const skeletonTab = Array.from({ length: 4 }, (_, i) => ({ id: `skeleton${i + 1}` }));
  const location = useLocation()
  const path = location.pathname
  const projectsToDisplay =
    path === "/projets" ? validProjects : validProjects?.slice(0, 4);


  return (
    <div
      className={`flex flex-col justify-center items-center pt-8  ${contener}`}
    >
      <div
        className="flex justify-center items-center flex-wrap w-[90%] ps-4"
        style={{ position: "relative", bottom: "50px" }}
      >
        <div className="flex flex-col space-y-4">
          <h1 className="text-4xl font-bold text-center text-noirel max-sm:text-lg max-lg:text-xl mb-0">
            Derniers projets sur le marché
          </h1>
          <p className="font-mandali font-normal text-base leading-6 text-center text-gris">
            Transformez vos compétences en revenus et gagnez <br />
            en expérience professionnelle !
          </p>
        </div>
        {/* 
        <div className={`flex justify-between flex-wrap w-4/5 ${position}`}>
          <h1
            className={`text-[2.8rem] max-xl:text-4xl max-lg:text-xl font-semibold font-inter text-noirel max-sm:text-lg ${title}`}
          ></h1>
          <div
            className={`w-3/5 flex justify-center py-2 max-xl:py-2 ${description}`}
          >
            <p
              className={`text-base leading-7 font-mandali max-xl:text-sm max-lg:text-xs text-gris w-11/12 ${width}`}
            ></p>
          </div>
        </div> */}
      </div>
      {!user && (
        <div className={`flex justify-center md:justify-end  w-[89%] ${display}`}>
          <MonBouton
            children={"Rejoindre un projet"}
            couleurFond={"bg-orange"}
            bordure={
              "border py-2 max-sm:py-1 max-sm:px-1 max-xl:text-sm  max-lg:p-1 rounded-full justify-center text-base font-inter text-white gap-2 font-sans font-medium max-sm:text-[15px] max-md:w-full max-lg:w-1/3 px-4   "
            }
            // iconRight={<IoIosArrowDroprightCircle size={"25px"} />}
            action={() => navigate("projets")}
            type={"button"}
          />
        </div>
      )}
      {selectCat && (
        <div className={`flex justify-center w-full`}>
          <SelectCategory
            id="projets"
            widthContainer={"!w-[60%] !justify-center"}
          />
        </div>
      )}
      {validProjects?.length > 4 && (
        <div className={`w-[88%] flex justify-end ${button}`}>
          <Link
            to={`${PROJECTSACCUEIL}`}
            className="w-1/5 flex items-center justify-end gap-2 text-vr "
          >
            <h4 className="text-base font-semibold font-inter text-noir_200 text-nowrap">
              Tout afficher
            </h4>
          </Link>
        </div>
      )}
      {isLoading ? (
        <div className={`flex max-md:gap-5 gap-7 w-[90%] flex-wrap pb-1`}>
          {skeletonTab.map((elem, i) => (
            <SkeletonLoader {...elem} key={i} cardProject={true} />
          ))}{" "}
        </div>
      ) : validProjects && validProjects?.length > 0 ? (
        <div
          className={`grid grid-cols-4 max-lg:grid-cols-3 max-md:grid-cols-1 w-[90%] gap-4 py-6`}
        >
          {projectsToDisplay?.map((elem, index) => (
            <CardprojectComponent
              key={index}
              image={elem?.image}
              budget={elem?.budget}
              titre={elem?.titre}
              etat={""}
              objectif={elem?.objectif}
              path={`/projets/${elem?.slug}`}
            />
          ))}
        </div>
      ) : (
        <div className="flex flex-col justify-center items-center py-28 gap-3">
          {/**<BsEmojiDizzyFill size={"40px"} />
          <h1 className="text-sm font-sans font-semibold text-center">
            Aucun projet disponible pour le moment </h1> */}
          <ProjectCards />
        </div>
      )}
    </div>
  );
}

export default ProjectSection